<!--
  Native <details>/<summary>. No JavaScript, no ARIA to get wrong, open by
  keyboard, findable by the browser's own in-page search, and indexable whether
  or not it is expanded.
-->
<section id="faqs" class="bg-ground pb-[112px]">
  <div class="mx-auto max-w-[1180px] px-8">
    <div class="grid gap-16 lg:grid-cols-[1fr_1.6fr] lg:gap-24">
      <div class="lg:sticky lg:top-[112px] lg:self-start">
        <p
          class="text-kicker uppercase text-accent reveal"
          appReveal
          i18n="@@faqsKicker"
        >
          Questions
        </p>
        <h2
          class="mt-kicker-gap text-headline text-ink text-balance reveal"
          appReveal
          i18n="@@faqsHeadline"
        >
          What it does, and what it will not do.
        </h2>
        <p
          class="mt-8 max-w-[38ch] text-body text-ink-2 reveal"
          appReveal
          i18n="@@faqsIntro"
        >
          Half of these are things Ledgerly does not do, on purpose. Better to
          know before you download than after.
        </p>
      </div>

      <div class="reveal" appReveal>
        @for (faq of faqs; track faq.question) {
        <details class="group border-b border-line">
          <summary
            class="flex cursor-pointer list-none items-start justify-between gap-8 py-8 text-row text-ink [&::-webkit-details-marker]:hidden"
          >
            <span>{{ faq.question }}</span>
            <span
              class="mt-1 flex h-4 w-4 flex-none items-center justify-center"
              aria-hidden="true"
            >
              <svg viewBox="0 0 12 12" class="h-3 w-3">
                <path
                  d="M6 1v10M1 6h10"
                  stroke="var(--color-accent-stroke)"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  class="origin-center transition-transform duration-300 group-open:rotate-45"
                />
              </svg>
            </span>
          </summary>
          <p class="max-w-[62ch] pb-8 text-body text-ink-2">{{ faq.answer }}</p>
        </details>
        }
      </div>
    </div>
  </div>
</section>
